import MultInputIntro from './mult-input-intro.vue';

export default {
  install(application) {
    application.component('yx-mult-input-intro', MultInputIntro);
  },
};
